function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.7 12.1a.99.99 0 10-1.4-1.4l-4.593 4.593a1 1 0 000 1.414L16.3 21.3a.99.99 0 101.4-1.4L13.8 16l3.9-3.9z",
  fill: "#6F8190"
});

var SvgIconArrowLeft = function SvgIconArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy43IDEyLjFDMTguMDg2NiAxMS43MTM0IDE4LjA4NjYgMTEuMDg2NiAxNy43IDEwLjdDMTcuMzEzNCAxMC4zMTM0IDE2LjY4NjYgMTAuMzEzNCAxNi4zIDEwLjdMMTEuNzA3MSAxNS4yOTI5QzExLjMxNjYgMTUuNjgzNCAxMS4zMTY2IDE2LjMxNjYgMTEuNzA3MSAxNi43MDcxTDE2LjMgMjEuM0MxNi42ODY2IDIxLjY4NjYgMTcuMzEzNCAyMS42ODY2IDE3LjcgMjEuM0MxOC4wODY2IDIwLjkxMzQgMTguMDg2NiAyMC4yODY2IDE3LjcgMTkuOUwxMy44IDE2TDE3LjcgMTIuMVoiIGZpbGw9IiM2RjgxOTAiLz4KPC9zdmc+Cg==";
export { SvgIconArrowLeft as ReactComponent };